import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";
// import Header from "../Layouts/Header";
import logo from "../assets/images/logofatoora.svg";
import dashboard1 from "../assets/images/dashboard-1.svg";
import settings from "../assets/images/settings.svg";
import userIcon from "../assets/images/userIcon.svg";
import membershipIcon from "../assets/images/membershipIcon.svg";
import invoiceIcon from "../assets/images/invoiceIcon.svg";
import reportsIcon from "../assets/images/reportsIcon.svg";
import seo from "../assets/images/presentation-chart-02.svg";
import contactreq from "../assets/images/Layer_1.svg";
import ref from "../assets/images/Layer_2.svg";
import sfinv from "../assets/images/receipt.svg";

import cms from "../assets/images/cms.svg";
import LogoutModel from "../Common/Popup/LogoutModel";
import { Modal } from "reactstrap";
import { useStateContext } from "../Common/Context/StateContext";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openpopup, setOpenpopup] = useState(false);
  const openPopup = useCallback(() => setOpenpopup(true), []);

  const [modal, setModal] = useState(false);

  const permission = JSON.parse(localStorage.getItem("permission") || "[]");
  const { setCurrentUrl, setCurrentCardTitle, currentCardTitle, currentUrl } =
    useStateContext();

  const hasPermission = (menu_id) => {
    const menuPermission = permission.find((perm) => perm.menu_id === menu_id);
    if (!menuPermission) {
      return false;
    } else return true;
  };

  const shouldShowGroup = (items) => {
    return items.some((item) => hasPermission(item.menu_id));
  };

  const menus = [
    {
      items: [
        {
          path: "/dashboard",
          label: "Dashboard",
          toplabel: "Dashboard",
          icon: dashboard1,
          menu_id: 1,
          permission_level: "",
        },
      ],
    },
  ];

  const isActive = useCallback((path) => location.pathname == path, [location]);

  const navigatePage = useCallback(
    (item) => {
      navigate(item.path);
      setCurrentUrl(item.label);
      setCurrentCardTitle(item.toplabel);
    },
    [navigate, setCurrentUrl, setCurrentCardTitle]
  );
  const toggleModal = useCallback(() => setModal(!modal), [modal]);

  return (
    <div>
      <Modal isOpen={modal} toggle={toggleModal}>
        <LogoutModel modal={modal} setModal={setModal} />
      </Modal>
      <div className="logo-sec">
        <a onClick={() => navigate("/")} className="logo">
          <img src={logo} alt="Logo" />
        </a>
      </div>
      <div className="sticky-sidebar">
        {menus
          .filter((menu) => shouldShowGroup(menu.items))
          .map((menu, index) => (
            <div key={index} className="menus">
              <h6>{menu.title}</h6>
              <ul>
                {menu.items
                  .filter((item) => hasPermission(1))
                  .map((item, indei) => {
                    return (
                      <li key={indei}>
                        <a
                          className={isActive(item.path) ? "active" : ""}
                          onClick={() =>
                            item.action ? item.action() : navigatePage(item)
                          }
                        >
                          <img src={item.icon} alt={item.label} /> {item.label}
                        </a>
                      </li>
                    );
                  })}
                {hasPermission(2) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#reports"
                      className="collapse-icon collapsed"
                    >
                      <img src={reportsIcon} alt="Custmer" /> Reports
                    </a>
                    <div
                      id="reports"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={
                            isActive("/freetrailreports") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/freetrailreports",
                            })
                          }
                        >
                          Free Trial
                        </a>

                        <a
                          className={
                            isActive("/invoicereports") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/invoicereports",
                            })
                          }
                        >
                          Invoice
                        </a>
                        <a
                          className={
                            isActive("/transactionreport") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/transactionreport",
                            })
                          }
                        >
                          Transaction
                        </a>
                        <a
                          className={
                            isActive("/paymentlogsreport") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/paymentlogsreport",
                            })
                          }
                        >
                          Payment Logs
                        </a>
                        <a
                          className={
                            isActive("/paymentsreport") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/paymentsreport",
                            })
                          }
                        >
                          Payments
                        </a>
                      </div>
                    </div>
                  </li>
                )}

                {hasPermission(3) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#members"
                      className="collapse-icon collapsed"
                    >
                      <img src={membershipIcon} alt="Custmer" /> Membership
                    </a>
                    <div
                      id="members"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={isActive("/membership") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/membership",
                              label: "Membership",
                              toplabel: "Memership List",
                            })
                          }
                        >
                          Membership List
                        </a>
                        <a
                          className={isActive("/addmembership") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/addmembership",
                              label: "Create Membership",
                              toplabel: "Create Membership",
                              icon: settings,
                            })
                          }
                        >
                          Create Membership
                        </a>

                        <a
                          className={
                            isActive("/addcustomermembership") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/addcustomermembership",
                              label: "Create Customer Member",
                              toplabel: "Create Customer Member",
                              icon: settings,
                            })
                          }
                        >
                          Create Membership for Customer
                        </a>
                        <a
                          className={isActive("/topuplist") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/topuplist",
                            })
                          }
                        >
                          Top-up
                        </a>
                        <a
                          className={isActive("/trialslist") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/trialslist",
                            })
                          }
                        >
                          Free Trials
                        </a>
                      </div>
                    </div>
                  </li>
                )}
                {hasPermission(4) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#referals"
                      className="collapse-icon collapsed"
                    >
                      <img src={ref} alt="Custmer" /> Referrals
                    </a>
                    <div
                      id="referals"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={isActive("/addreferal") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/addreferal",
                              label: "Add Referal",
                              toplabel: "Add Referral",
                            })
                          }
                        >
                          Add Customer Referral
                        </a>
                        <a
                          className={isActive("/referallist") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/referallist",
                              label: "Referral List",
                              toplabel: "Referral List",
                            })
                          }
                        >
                          Referral List
                        </a>
                      </div>
                    </div>
                  </li>
                )}
                {hasPermission(5) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#customer"
                      className="collapse-icon collapsed"
                    >
                      <img src={userIcon} alt="Custmer" /> Customer
                    </a>
                    <div
                      id="customer"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={isActive("/user") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/user",
                              label: "Customer List",
                              toplabel: "Customer List",
                              // icon: settings,
                            })
                          }
                        >
                          Customer List
                        </a>
                        <a
                          className={isActive("/user/add") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/user/add",
                              label: "Create Customer",
                              toplabel: "Create Customer",
                              icon: settings,
                            })
                          }
                        >
                          Create Customer
                        </a>

                        <a
                          className={isActive("/customer360") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/customer360",
                              label: "Customer 360",
                              toplabel: "Customer 360",
                              icon: settings,
                            })
                          }
                        >
                          Customer 360
                        </a>

                        <a
                          className={isActive("/user-journey") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/user-journey",
                              label: "User Journey Tracking",
                              toplabel: "User Journey Tracking",
                              icon: settings,
                            })
                          }
                        >
                          User Journey Tracking
                        </a>

                        <a
                          className={
                            isActive("/customermembership") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/customermembership",
                              label: "Customer with Membership",
                              toplabel: "Customer with Membership",
                              icon: settings,
                            })
                          }
                        >
                          Customer with Membership
                        </a>
                      </div>
                    </div>
                  </li>
                )}
                {hasPermission(6) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#tickets"
                      className="collapse-icon collapsed"
                    >
                      <img src={contactreq} alt="Custmer" /> Contact Request
                    </a>
                    <div
                      id="tickets"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={isActive("/ticketslist") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/ticketslist",
                              label: "Tickets List",
                              toplabel: "Tickets List",
                              // icon: settings,
                            })
                          }
                        >
                          Query List
                        </a>
                        <a
                          className={
                            isActive("/userticketslist") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/userticketslist",
                            })
                          }
                        >
                          User Tickets
                        </a>
                        <a
                          className={isActive("/enqurieslist") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/enqurieslist",
                            })
                          }
                        >
                          Enquiries
                        </a>
                      </div>
                    </div>
                  </li>
                )}

                {hasPermission(7) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#invoice"
                      className="collapse-icon collapsed"
                    >
                      <img src={invoiceIcon} alt="Customer documents" /> Customer Documents
                    </a>
                    <div
                      id="invoice"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={isActive("/invoice") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/invoice",
                              label: "Document List",
                              toplabel: "Customer Documents",
                            })
                          }
                        >
                          Document List
                        </a>
                        {/* <a
                          className={isActive("/addinvoice") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/addinvoice",
                            })
                          }
                        >
                          Create Invoice
                        </a> */}
                        {/* <a
                          className={
                            isActive("/addcreditnotes") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/addcreditnotes",
                            })
                          }
                        >
                          Create Credit Note
                        </a> */}
                        {/* <a
                          className={isActive("/adddebitnotes") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/adddebitnotes",
                            })
                          }
                        >
                          Create Debit Note
                        </a> */}
                      </div>
                    </div>
                  </li>
                )}
                {hasPermission(8) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#sfinvoice"
                      className="collapse-icon collapsed"
                    >
                      <img src={sfinv} alt="Custmer" /> SF Invoices
                    </a>
                    <div
                      id="sfinvoice"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={isActive("/addinvoices") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/addinvoices",
                            })
                          }
                        >
                          Create Invoice
                        </a>

                        <a
                          className={
                            isActive("/addcreditnotess") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/addcreditnotess",
                            })
                          }
                        >
                          Create Credit Note
                        </a>
                        <a
                          className={
                            isActive("/adddebitnotess") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/adddebitnotess",
                            })
                          }
                        >
                          Create Debit Note
                        </a>
                        <li>
                          <a
                            data-toggle="collapse"
                            data-target="#sfinvoicetwo"
                            className="collapse-icon collapsed"
                          >
                            Invoices
                          </a>
                          <div
                            id="sfinvoicetwo"
                            className="collapse"
                            style={{ paddingLeft: "35px" }}
                          >
                            <div>
                               <a
                          className={isActive("/invoices") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/invoices",
                              label: "Invoice List",
                              toplabel: "Invoice List",
                            })
                          }
                        >
                          Invoice List
                        </a>
                              <a
                                className={
                                  isActive("/topupreports") ? "active" : ""
                                }
                                onClick={() =>
                                  navigatePage({
                                    path: "/topupreports",
                                  })
                                }
                              >
                                Top-up Invoices
                              </a>
                              <a
                                className={
                                  isActive("/membership_invoice")
                                    ? "active"
                                    : ""
                                }
                                onClick={() =>
                                  navigatePage({
                                    path: "/membership_invoice",
                                  })
                                }
                              >
                                Membership Invoice
                              </a>
                            </div>
                          </div>
                        </li>
                        <a
                          className={
                            isActive("/creditnoteslists") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/creditnoteslists",
                            })
                          }
                        >
                          Credit Notes
                        </a>
                        <a
                          className={
                            isActive("/debitnoteslists") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/debitnoteslists",
                            })
                          }
                        >
                          Debit Notes
                        </a>
                        <a
                          className={isActive("/vatreport") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/vatreport",
                            })
                          }
                        >
                          VAT Report
                        </a>

                       
                      </div>
                    </div>
                  </li>
                )}
                {hasPermission(9) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#settings"
                      className="collapse-icon collapsed"
                    >
                      <img src={settings} alt="Custmer" /> Master
                    </a>
                    <div
                      id="settings"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={isActive("/settings") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/settings",
                              label: "Settings",
                              toplabel: "Settings List",
                              // icon: settings,
                            })
                          }
                        >
                          Settings List
                        </a>
                        <a
                          className={
                            isActive("/zatca-downtime") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/zatca-downtime",
                              label: "ZATCA Hold",
                              toplabel: "ZATCA Hold",
                            })
                          }
                        >
                          ZATCA Hold
                        </a>
                        <a className={isActive("/invoice-email-senders") ? "active" : ""} onClick={() => navigatePage({path: "/invoice-email-senders", label: "Invoice email senders", toplabel: "Invoice email senders"})}>Invoice email senders</a>
                        <a className={isActive("/outgoing-invoice-emails") ? "active" : ""} onClick={() => navigatePage({path: "/outgoing-invoice-emails", label: "Outgoing emails", toplabel: "Outgoing invoice emails"})}>Outgoing emails</a>
                        <a
                          className={
                            isActive("/shopify-membership-monitor")
                              ? "active"
                              : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/shopify-membership-monitor",
                              label: "Shopify Monitor",
                              toplabel: "Shopify Membership Monitor",
                            })
                          }
                        >
                          Shopify Monitor
                        </a>
                        <a
                          className={isActive("/category/add") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/category/add",
                            })
                          }
                        >
                          Add Category
                        </a>
                        <a
                          className={isActive("/categories") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/categories",
                              label: "Category List",
                              toplabel: "Category List",
                              icon: settings,
                            })
                          }
                        >
                          Category List
                        </a>

                        <a
                          className={isActive("/services") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/services",
                              label: "Service",
                              toplabel: "Service  List",
                              icon: settings,
                            })
                          }
                        >
                          Service
                        </a>
                        <a
                          className={isActive("/admin") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/admin",
                              label: "Admin List",
                              toplabel: "Admin List",
                            })
                          }
                        >
                          Admin
                        </a>
                      </div>
                    </div>
                  </li>
                )}
                {hasPermission(10) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#demo"
                      className="collapse-icon collapsed"
                    >
                      <img src={cms} alt="CMS" /> CMS
                    </a>
                    <div
                      id="demo"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={isActive("/cms") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/cms",
                              label: "CMS",
                              toplabel: "CMS",
                              icon: settings,
                            })
                          }
                        >
                          Section 1 - Banner
                        </a>
                        <a
                          className={isActive("/section2") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/section2",
                              label: "CMS",
                              toplabel: "CMS",
                              icon: settings,
                            })
                          }
                        >
                          Section 2 - Brand
                        </a>

                        <a
                          className={
                            isActive("/sectionwhychooose") ? "active" : ""
                          }
                          onClick={() =>
                            navigatePage({
                              path: "/sectionwhychooose",
                              label: "CMS",
                              toplabel: "CMS",
                              icon: settings,
                            })
                          }
                        >
                          Section 3 - Why Fatoora
                        </a>
                        <a
                          className={isActive("/section3") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/section3",
                              label: "CMS",
                              toplabel: "CMS",
                              icon: settings,
                            })
                          }
                        >
                          Section 4 - Steps
                        </a>
                        <a
                          className={isActive("/section4") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/section4",
                              label: "CMS",
                              toplabel: "CMS",
                              icon: settings,
                            })
                          }
                        >
                          Section 5 - Features
                        </a>
                        <a
                          className={isActive("/section5") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/section5",
                              label: "CMS",
                              toplabel: "CMS",
                              icon: settings,
                            })
                          }
                        >
                          Section 6 - Who For
                        </a>
                        <a
                          className={isActive("/sectionfaq") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/sectionfaq",
                              label: "CMS",
                              toplabel: "CMS",
                              icon: settings,
                            })
                          }
                        >
                          Section 7 - Faqs
                        </a>
                      </div>
                    </div>
                  </li>
                )}

                {hasPermission(11) && (
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#seo"
                      className="collapse-icon collapsed"
                    >
                      <img src={seo} alt="SEO" /> SEO
                    </a>
                    <div
                      id="seo"
                      className="collapse"
                      style={{ paddingLeft: "35px" }}
                    >
                      <div>
                        <a
                          className={isActive("/seo") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/seo",
                              label: "SEO",
                              toplabel: "SEO - Home",
                              icon: settings,
                            })
                          }
                        >
                          Home
                        </a>
                        <a
                          className={isActive("/pricing") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/pricing",
                              label: "SEO",
                              toplabel: "SEO - Pricing",
                              icon: settings,
                            })
                          }
                        >
                          Pricing
                        </a>

                        <a
                          className={isActive("/faq") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/faq",
                              label: "SEO",
                              toplabel: "SEO - FAQ",
                              icon: settings,
                            })
                          }
                        >
                          Faq
                        </a>
                        <a
                          className={isActive("/tap_manager") ? "active" : ""}
                          onClick={() =>
                            navigatePage({
                              path: "/tap_manager",
                              label: "SEO",
                              toplabel: "SEO - TAG MANAGER",
                              icon: settings,
                            })
                          }
                        >
                          Tag Manager
                        </a>
                      </div>
                    </div>
                  </li>
                )}
                <li className={openpopup ? " active" : ""}>
                  <a onClick={toggleModal}>
                    <i
                      className=" fa fa-sign-out"
                      style={{ fontSize: "24px" }}
                    ></i>
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          ))}
      </div>
      <Modal isOpen={modal} toggle={toggleModal}>
        <LogoutModel modal={modal} setModal={setModal} />
      </Modal>
    </div>
  );
};

export default Sidebar;
